export const URL_FORMAT = {
  canonical: 'https://example.com/',

  validate(value: string): boolean {
    return this.normalize(value) !== undefined
  },

  normalize(value: string | undefined | null): string | undefined {
    if (!value || !value.trim()) return undefined

    const trimmed = value.trim()

    if (trimmed.includes('@') && !trimmed.includes('://')) {
      return undefined
    }

    try {
      const withProtocol = /^https?:\/\//.test(trimmed) ? trimmed : `https://${trimmed}`
      const parsed = new URL(withProtocol)

      if (!parsed.hostname || parsed.hostname.includes('@')) {
        return undefined
      }

      return parsed.href
    } catch {
      return undefined
    }
  },

  errorMessage: 'Enter a valid URL',
} as const
